export default {
 proxyCookies: true,
 clientAwareness: false,
 cookieAttributes: {"maxAge": 604800, "secure": true},
 authType: "Bearer",
 authHeader: "Authorization",
 tokenStorage: "cookie"
}